import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { useWidgetOfType } from '@src/components/pl-base-widget/contexts/page-widget-store'

/**
 * Whether the current PL page is a bundle PDP — detected by the presence of a bundle buy-box widget in
 * the page widget store (a bundle layout ships BUNDLE_PURCHASE, or BUNDLE_PURCHASE_V2 on an SVD session,
 * instead of PRODUCT_PURCHASE). The reviews widgets hide the write-a-review CTA on bundles for non-PL
 * parity: `product-reviews-legacy` passes `hideWriteReviewButton={product.type === PRODUCT_TYPES.BUNDLE …}`
 * to both the summary and the NoReviews empty state, because a review is written against a real
 * product (a bundle child), not the bundle itself — the popup's product id
 * (`context.pdp.productIds.productId`) would otherwise target the bundle.
 */
export function useIsBundlePdp(): boolean {
  const isV1Bundle = useWidgetOfType(WidgetType.BUNDLE_PURCHASE) !== undefined
  const isV2Bundle = useWidgetOfType(WidgetType.BUNDLE_PURCHASE_V2) !== undefined
  return isV1Bundle || isV2Bundle
}
